import { apiClient } from '@/api/client';
import { ENDPOINTS } from '@/api/endpoints';

export const getUnreviewedBookingsCheck = async () => {
  return await apiClient.get(`${ENDPOINTS.BOOKINGS}/unreviewed/check`);
};
